<template>
  <div class="upload-preview">
    <div class="scene_title blue_header">
      <!-- 灯带场景信息 -->
      <span>{{ $t("sceneCard.lightTripImg") }}</span>
    </div>
    <div class="scene_container upload-preview_container">
      <div class="scene_container_preview">
        <!-- 灯带排列图 -->
        <p class="upload-preview_title">
          {{ $t("sceneCard.lightTripRankImg") }}: <span>{{ stripDialogInfo.row }} x {{ stripDialogInfo.col }}</span>
        </p>
        <div id="preview_canvas" />
      </div>
      <div class="scene_container_upload">
        <!-- 上传图片 -->
        <p class="upload-preview_title">
          {{ $t("visual.uploadImg") }}
        </p>
        <div class="upload_box">
          <el-upload
            class="avatar-uploader"
            action=""
            accept="image/*"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onChange"
          >
            <img
              v-show="imageUrl"
              :src="imageUrl"
              class="avatar"
            >
            <div
              v-if="!imageUrl"
              class=""
            >
              <i
                class="el-icon-plus avatar-uploader-icon"
              />
              <p>{{ $t('visual.please') }}{{ $t('visual.uploadImg') }}, {{ $t('visual.imgSize') }}{{ stripDialogInfo.row }}x{{ stripDialogInfo.col }}px，{{ $t('visual.lessThen') }}100K</p>
            </div>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DesignCanvas, { loadAsyncImg } from '@/components/DesignCanvas/index';
import { UploadFile } from "@/axios/ICommon.js";

export default {
  props: {
    stripDialogInfo: {
      type: Object,
      default: () => ({})
    },
    canvasInitData: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      imageUrl: '',
      designCanvasInstance: null
    }
  },

  // watch: {
  //   canvasInitData(data) {
  //     console.log('canvasInitData watch');
      
  //     if (data && data.bg && initData.bg.url) {
  //       this.createCanvas({
  //         url: initData.bg.url,
  //       });
  //     }
  //   }
  // },

  mounted() {
    const { canvasInitData } = this;

    if (canvasInitData && canvasInitData.bg && canvasInitData.bg.url) {
      const origin = window.location.origin;
      const url = canvasInitData.bg.url;
      // canvasInitData.bg.url.replace(
      //   'https://appresource.opple.com', 
      //   origin.includes('//localhost:') ? 'https://stage.opple.com' : origin);
      
      this.imageUrl = url;
      this.createCanvas({
        url: url
      });
    }
  },

  methods: {
    createCanvas(canvasOp) {
      const designCanvasInstance = new DesignCanvas(canvasOp);

      designCanvasInstance.drawBitmap('#preview_canvas', {
        autoHeight: true
      });

      // 获取数据包括xzy数据
      designCanvasInstance.getAsyncInstacneData().then(data => {
        this.$emit('imgUpdate', {
          designCanvasInstance,
          bgUrl: canvasOp.url
        });
      })

      this.imageUrl = canvasOp.url;
    },
    // 上传成功
    async onChange(file) {
      const { row, col } = this.stripDialogInfo;
    
      const url = URL.createObjectURL(file.raw);
      const img = await loadAsyncImg(url);

      const { width, height } = img;

      if (width !== Number(row) || height !== Number(col)) {
        this.$message.error(`${this.$t('visual.uploadImg')}${this.$t('sceneCard.size')}${row} x ${col}`)

        return;
      }
      
      if (file.size > 100000) {
        this.$message.error(`${this.$t('visual.uploadImg')}${this.$t('lastLight.lessthan')}100k`)

        return;
      }

      const formData = new FormData();
  
      formData.append("file", file.raw);

      UploadFile(formData, (res) => {
        if (res.StatusCode === this.$store.state.rightStatusCode) {
           const cdnUrl = res.Result.RootPath + res.Result.FilePath;

           this.createCanvas({
              url: cdnUrl,
              // 该值告知组件图片基础信息 可不传 不传的情况组件内部可自动解析
              originImgData: img
           });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-preview_title {
  font-size: 12px;
  padding-bottom: 20px;
}
.upload-preview_container {
  display: flex;

  .scene_container_preview {
    margin-right: 5%;
  }
}

#preview_canvas {
  width: 478px;
  height: 238px;
}

.upload_box {
  display: flex;
  width: 478px;
  height: 238px;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  color: #D0D0D0;
  overflow: hidden;

  p {
    margin-top: 10px;
  }
  ::v-deep .el-icon-plus {
    font-size: 80px;
    font-weight: bold;
    
  }

  img {
    max-width: 100%;
  }
}

</style>
